import { render, staticRenderFns } from "./SurfaceTitle.vue?vue&type=template&id=66068424&"
import script from "./SurfaceTitle.vue?vue&type=script&lang=ts&"
export * from "./SurfaceTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports